// Create a BroadcastChannel
const cartChannel = new BroadcastChannel('cart_channel');

function getMaxSamples() {
  const fromThemeSetting = Number.parseInt(window.sampleMax, 10);
  return Number.isFinite(fromThemeSetting) && fromThemeSetting > 0 ? fromThemeSetting : 5;
}

function getSampleVariantIdFromEl(sampleButton) {
  if (!sampleButton) return null;

  // Preferred: explicit data attribute.
  const fromData = sampleButton.getAttribute('data-sample-variant-id') || sampleButton.dataset?.sampleVariantId;
  if (fromData && /^\d+$/.test(String(fromData))) return String(fromData);

  // Fallback: parse legacy onclick="addItem(123, 1)".
  const onclickAttr = sampleButton.getAttribute('onclick');
  if (onclickAttr) {
    const match = onclickAttr.match(/addItem\s*\(\s*(\d+)\s*,/);
    if (match && match[1]) return match[1];
  }

  return null;
}

function isSampleLineItem(item) {
  return Boolean(item?.handle && item.handle.endsWith('-s'));
}

function isLimitExemptLineItem(item) {
  const exemptProp = item?.properties?._sample_limit_exempt;
  return exemptProp === true || exemptProp === 'true';
}

function isCheckerboardSampleLineItem(item) {
  return item?.properties?._sample_style === 'checkerboard';
}

function countsTowardSampleLimit(item) {
  return isSampleLineItem(item) && !isLimitExemptLineItem(item) && !isCheckerboardSampleLineItem(item);
}

function buttonIsLimitExempt(sampleButton) {
  if (!sampleButton) return false;
  if (sampleButton?.dataset?.sampleStyle === 'checkerboard') return true;
  return sampleButton?.dataset?.sampleLimitExempt === 'true';
}

function getSampleButtonStyle(sampleButton) {
  return sampleButton?.dataset?.sampleStyle || 'default';
}

function getSampleButtonDefaultLabel(sampleButton) {
  return sampleButton?.dataset?.sampleDefaultLabel || 'Get a sample';
}

function getSampleButtonDefaultSubtext(sampleButton) {
  return sampleButton?.dataset?.sampleDefaultSubtext || 'FREE 5 Samples + $14.99 Flat Rate shipping';
}

function getCheckerboardGroup(sampleButton) {
  return sampleButton?.dataset?.checkerboardGroup || '';
}

function itemMatchesCheckerboardGroup(item, checkerboardGroup) {
  if (!checkerboardGroup) return false;
  return item?.properties?._checkerboard_group === checkerboardGroup;
}

function getSampleButtons() {
  return Array.from(document.querySelectorAll('.sample-container .sample-button'));
}

function getRemainingSampleSlots(maxSamples, uniqueLimitedSamples) {
  return Math.max(maxSamples - uniqueLimitedSamples.size, 0);
}

function getAddedStateIconMarkup() {
  return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6667 3.5L5.25001 9.91667L2.33334 7" stroke="#A7A7A7" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

function setSampleButtonContent(sampleButton, label, subtext, icon) {
  const sampleButtonLabel = sampleButton.querySelector('.sample-button__label');
  const sampleButtonSubtext = sampleButton.querySelector('.sample-button__subtext');
  const sampleButtonIcon = sampleButton.querySelector('.sample-button__status-icon');

  if (sampleButtonLabel) {
    sampleButtonLabel.textContent = label;
  }

  if (sampleButtonSubtext) {
    sampleButtonSubtext.textContent = subtext;
  }

  if (sampleButtonIcon) {
    if (icon === 'checkmark') {
      sampleButtonIcon.innerHTML = getAddedStateIconMarkup();
    } else {
      sampleButtonIcon.textContent = icon || '';
    }
  }
}

function setSampleButtonState(sampleButton, state, options = {}) {
  const {
    label,
    subtext,
    icon = '+',
    disabled = false
  } = options;

  sampleButton.setAttribute('data-sample-state', state);

  if (disabled) {
    sampleButton.setAttribute('data-disabled', 'true');
  } else {
    sampleButton.removeAttribute('data-disabled');
  }

  setSampleButtonContent(sampleButton, label, subtext, icon);
}

// Function to update cart data across all tabs
function updateCartData(cartData) {
  console.log("Updating cart data in localStorage and broadcasting.");
  localStorage.setItem('cartData', JSON.stringify(cartData));
  cartChannel.postMessage(cartData);
}

// Function to handle cart updates from other tabs
cartChannel.onmessage = (event) => {
  const cartData = event.data;
  console.log("Received cart data from another tab:", cartData);
  localStorage.setItem('cartData', JSON.stringify(cartData));
  refreshButtonStatus(cartData);  // Update the UI as needed
};

// Function to refresh button status
function refreshButtonStatus(cart) {
  console.log("Refreshing button status with cart data:", cart);

  const maxSamples = getMaxSamples();
  const sampleButtons = getSampleButtons();
  if (!sampleButtons.length) {
    console.log('Sample buttons not found.');
    return;
  }

  const uniqueLimitedSamples = new Set();
  const sampleVariantsInCart = new Set();
  const checkerboardGroupsInCart = new Set();
  (cart?.items || []).forEach((item) => {
    if (isSampleLineItem(item)) {
      sampleVariantsInCart.add(String(item.variant_id));
    }
    if (isCheckerboardSampleLineItem(item) && item?.properties?._checkerboard_group) {
      checkerboardGroupsInCart.add(item.properties._checkerboard_group);
    }
    if (countsTowardSampleLimit(item)) {
      uniqueLimitedSamples.add(String(item.variant_id));
    }
  });

  console.log('Unique limited samples in cart:', uniqueLimitedSamples.size);

  sampleButtons.forEach((sampleButton) => {
    const sampleContainer = sampleButton.closest('.sample-container');
    const sampleVariantId = getSampleVariantIdFromEl(sampleButton);

    if (!sampleContainer || !sampleVariantId) {
      return;
    }

    const limitExempt = buttonIsLimitExempt(sampleButton);
    const sampleStyle = getSampleButtonStyle(sampleButton);
    const defaultLabel = getSampleButtonDefaultLabel(sampleButton);
    const defaultSubtext = getSampleButtonDefaultSubtext(sampleButton);
    const checkerboardGroup = getCheckerboardGroup(sampleButton);
    const productInCart = sampleVariantsInCart.has(String(sampleVariantId));
    const matchingCheckerboardGroupInCart = sampleStyle === 'checkerboard' && checkerboardGroupsInCart.has(checkerboardGroup);
    const remainingSamples = getRemainingSampleSlots(maxSamples, uniqueLimitedSamples);

    sampleContainer.style.visibility = 'visible';

    if (!limitExempt && uniqueLimitedSamples.size >= maxSamples && !productInCart) {
      setSampleButtonState(sampleButton, 'limit-reached', {
        label: 'MAX SAMPLES REACHED',
        subtext: 'You have 0 samples left for your order',
        icon: '',
        disabled: true
      });
    } else if (productInCart) {
      setSampleButtonState(sampleButton, 'added', {
        label: sampleStyle === 'checkerboard' ? 'SAMPLE BUNDLE ADDED TO CART' : 'SAMPLE ADDED TO CART',
        subtext: sampleStyle === 'checkerboard'
          ? 'Add More for Only $5.00!'
          : `You have ${remainingSamples} sample${remainingSamples === 1 ? '' : 's'} left for your order`,
        icon: 'checkmark',
        disabled: true
      });
    } else {
      setSampleButtonState(sampleButton, 'default', {
        label: defaultLabel,
        subtext: matchingCheckerboardGroupInCart
          ? 'Add More for Only $5.00!'
          : defaultSubtext,
        icon: '+',
        disabled: false
      });
    }
  });
}

// Function to add item to cart
function addItem(id, quantity, options = {}) {
  // Create an items array with the item ID and quantity to be added
  let items = [{
      id: id,
      quantity: quantity,
      properties: options.properties || {}
  }];
  
  // Send a POST request to the Shopify API to add the item to the cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
  })
  .then(response => response.json())
  .then(data => {
      if (data.status && data.status === 'error') {
          console.error('Error adding item to cart:', data.message);
          return;
      }
      // Update the localStorage with the new cart data
      theme.cart.getCartData().then(cartData => {
        updateCartData(cartData);  // Update cart data and broadcast to other tabs
        // Dispatch a 'cart:build' event to rebuild the cart
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
      }).catch(error => {
        console.error('Error getting cart data:', error);
      });
  })
  .catch(error => {
      console.error('Error adding item to cart:', error);
  });
}

// Add a sample item with live cart validation (max + duplicates)
function addSampleItem(variantId, quantity, options = {}) {
  const maxSamples = getMaxSamples();
  const limitExempt = options.limitExempt === true;

  return theme.cart.getCartData().then((cartData) => {
    if (!cartData) return;

    const uniqueLimitedSamples = new Set();
    let alreadyInCart = false;

    (cartData.items || []).forEach((item) => {
      if (isSampleLineItem(item)) {
        if (String(item.variant_id) === String(variantId)) {
          alreadyInCart = true;
        }
      }
      if (countsTowardSampleLimit(item)) {
        uniqueLimitedSamples.add(String(item.variant_id));
      }
    });

    // Keep local cache in sync (important for UI + other tabs)
    localStorage.setItem('cartData', JSON.stringify(cartData));
    refreshButtonStatus(cartData);

    if (alreadyInCart) {
      console.log('Sample is already in cart, not adding duplicate.');
      return;
    }

    if (!limitExempt && uniqueLimitedSamples.size >= maxSamples) {
      console.log('Max samples reached, not adding more samples.');
      return;
    }

    const properties = limitExempt
      ? {
          _sample_limit_exempt: 'true',
          ...(options.sampleStyle ? { _sample_style: options.sampleStyle } : {}),
          ...(options.checkerboardGroup ? { _checkerboard_group: options.checkerboardGroup } : {})
        }
      : {
          ...(options.sampleStyle ? { _sample_style: options.sampleStyle } : {}),
          ...(options.checkerboardGroup ? { _checkerboard_group: options.checkerboardGroup } : {})
        };
    return addItem(variantId, quantity, { properties });
  }).catch((error) => {
    console.error('Error validating sample limit:', error);
  });
}

// Function to remove item from cart
function removeItem(id) {
  // Create an updates object with the item ID set to 0 (removing the item)
  let updates = {};
  updates[id] = 0;
  
  // Send a POST request to the Shopify API to update the cart
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .then(data => {
    // Update the localStorage with the new cart data
    theme.cart.getCartData().then(cartData => {
      updateCartData(cartData);  // Update cart data and broadcast to other tabs
      // Dispatch a 'cart:build' event to rebuild the cart
      document.dispatchEvent(new CustomEvent('cart:build'));
      // Refresh the button status
      refreshButtonStatus(cartData);
    }).catch(error => {
      console.error('Error getting cart data:', error);
    });
  })
  .catch(error => {
    console.error('Error removing item from cart:', error);
  });
}

// Initial setup to load and synchronize cart data on page load
document.addEventListener('DOMContentLoaded', function() {  
  // Get the cart data and refresh the button status
  theme.cart.getCartData().then((cartData) => {
    if (!cartData) {
      return;
    }

    localStorage.setItem('cartData', JSON.stringify(cartData));
    refreshButtonStatus(cartData);
  }).catch((error) => {
    console.error("Error getting cart data:", error);
  });

  // Modify the onclick event to use addItem function
  const sampleButtons = getSampleButtons();

  if (sampleButtons.length) {
    sampleButtons.forEach((sampleButton) => {
      sampleButton.onclick = (event) => {
      event.preventDefault();

      if (sampleButton.getAttribute('data-disabled') === 'true') {
        return;
      }

      sampleButton.setAttribute('data-disabled', 'true');

      const sampleVariantId = getSampleVariantIdFromEl(sampleButton);
      if (!sampleVariantId) {
        console.log('Sample variant ID not found on click.');
        return;
      }
      addSampleItem(sampleVariantId, 1, {
        limitExempt: buttonIsLimitExempt(sampleButton),
        sampleStyle: getSampleButtonStyle(sampleButton),
        checkerboardGroup: getCheckerboardGroup(sampleButton)
      });

      theme.cart.getCartData().then((cartData) => {
        refreshButtonStatus(cartData);
      }).catch((error) => {
        console.error("Error getting cart data:", error);
      });
      };
    });
  } else {
    console.log('Sample button not found during initial setup.');
  }

  // Listen for the 'ajaxProduct:added' event to refresh the button status
  document.addEventListener('ajaxProduct:added', () => {
    console.log("ajaxProduct:added event received.");
    theme.cart.getCartData().then((cartData) => {
      localStorage.setItem('cartData', JSON.stringify(cartData));
      refreshButtonStatus(cartData);
    }).catch((error) => {
      console.error("Error getting cart data:", error);
    });
  });

  // Listen for the 'cart:build' event to refresh the button status
  document.addEventListener('cart:build', () => {
    console.log("cart:build event received.");
    theme.cart.getCartData().then((cartData) => {
      localStorage.setItem('cartData', JSON.stringify(cartData));
      refreshButtonStatus(cartData);
    }).catch((error) => {
      console.error("Error getting cart data:", error);
    });
  });
});
